import Swiper from 'swiper';
import { Grid, Pagination } from 'swiper/modules';

let gameSwipers = new Map(); // Store multiple swiper instances

function initOrDestroySwiper() {
  const containers = document.querySelectorAll('.game-slider .swiper');
  const isMobile = window.innerWidth <= 767;

  containers.forEach(container => {
    const containerId = container.id || container.closest('.game-slider').id || `game-slider-${Array.from(containers).indexOf(container)}`;
    
    // Get limits from the first game card data attributes in this container
    const firstGameCard = container.querySelector('.game-card[data-limit-desktop]');
    const limitDesktop = firstGameCard ? parseInt(firstGameCard.dataset.limitDesktop, 10) : 7;
    const limitMobile = firstGameCard ? parseInt(firstGameCard.dataset.limitMobile, 10) : 50;

    if (isMobile && !gameSwipers.has(containerId)) {
      if (!container.querySelector('.swiper-pagination')) {
        const pag = document.createElement('div');
        pag.className = 'swiper-pagination';
        container.appendChild(pag);
      }

      const swiper = new Swiper(container, {
        modules: [Grid, Pagination],
        slidesPerView: 3,
        slidesPerGroup: 3, // Move 3 slides at a time (one row)
        grid: {
          rows: 2,
          fill: 'row',
        },
        spaceBetween: 8,
        centeredSlides: false,
        normalizeSlideIndex: true,
        roundLengths: true,
        watchSlidesProgress: true,
        pagination: {
          el: container.querySelector('.swiper-pagination'),
          clickable: true,
          dynamicBullets: true,
        },
        breakpoints: {
          // Adjust for different screen sizes if needed
          480: {
            spaceBetween: 10,
          }
        },
        on: {
          slideChange: function() {
            // Force recalculation of slide positions
            this.updateSlides();
            this.updateProgress();
          }
        }
      });
      
      gameSwipers.set(containerId, swiper);
    }
    else if (!isMobile && gameSwipers.has(containerId)) {
      const swiper = gameSwipers.get(containerId);
      swiper.destroy(true, true);
      gameSwipers.delete(containerId);
      const pag = container.querySelector('.swiper-pagination');
      if (pag) pag.remove();
    }

    // Show/hide games based on device type for this container
    const mobileOnlyGames = container.querySelectorAll('.mobile-only-game');
    
    if (isMobile) {
      // On mobile: show all games including mobile-only ones
      mobileOnlyGames.forEach(game => {
        game.style.display = '';
        game.classList.remove('mobile-only-game'); // Remove class so it doesn't get hidden by CSS
      });
    } else {
      // On desktop: ensure mobile-only games stay hidden
      mobileOnlyGames.forEach(game => {
        game.style.display = 'none';
      });
    }
  });
}

// on load
window.addEventListener('DOMContentLoaded', initOrDestroySwiper);
// on resize (debounced)
let resizeTimeout;
window.addEventListener('resize', () => {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(initOrDestroySwiper, 200);
});

// Run immediately if DOM is already loaded to prevent flicker
if (document.readyState === 'loading') {
  // DOM hasn't finished loading yet
  window.addEventListener('DOMContentLoaded', initOrDestroySwiper);
} else {
  // DOM has already loaded
  initOrDestroySwiper();
}
